import { render, staticRenderFns } from "./DeleteConfirmDialog.vue?vue&type=template&id=bcfbe460&scoped=true&"
import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=bcfbe460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfbe460",
  null
  
)

export default component.exports